import { jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from "react";
let pending = [];
let fetching = [];
let fetchSvgContentTimeoutId = null;
let numRequests = 0;
setInterval(() => numRequests = 0, 1e4);
const svgIconEventTarget = new EventTarget();
function requestIconsEqual(icon1, icon2) {
  return icon1.src === icon2.src && icon1.alt === icon2.alt;
}
function fetchSvgContent(src, alt) {
  if (pending.some(icon => icon.src === src && icon.alt === alt)) return;
  if (pending.length > 100) return;
  pending.push({
    src,
    alt
  });
  async function debouncedFetch() {
    if (pending.length === 0) return;
    if (numRequests > 50) return;
    numRequests++;
    const icons = pending.filter(pendingIcon => !fetching.some(fetchingIcon => requestIconsEqual(pendingIcon, fetchingIcon)));
    fetching = [...fetching, ...icons];
    const paths = encodeURIComponent(icons.map(icon => icon.src).join(","));
    const alts = encodeURIComponent(icons.map(icon => icon.alt).join(","));
    const url = `/command-center/utility/getIcons?paths=${paths}&alts=${alts}`;
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!response.ok) {
      fetching = fetching.filter(fetchingIcon => !icons.some(icon => requestIconsEqual(icon, fetchingIcon)));
      console.error(`received non-ok response code ${response.status} from ${url}`);
      return;
    }
    const json = await response.json();
    if (json.status !== 200) {
      fetching = fetching.filter(fetchingIcon => !icons.some(icon => requestIconsEqual(icon, fetchingIcon)));
      console.error(`received non-ok response code ${json.status} from ${url}${json.message ? `, message ${json.message}` : ""}`);
      console.error(json);
      return;
    }
    const svgIconEvent = new CustomEvent("newicons", {
      detail: {
        icons: json.icons
      }
    });
    svgIconEventTarget.dispatchEvent(svgIconEvent);
    fetching = fetching.filter(fetchingIcon => !icons.some(icon => icon.src === fetchingIcon.src && icon.alt === fetchingIcon.alt));
    pending = pending.filter(pendingIcon => !icons.some(icon => icon.src === pendingIcon.src && icon.alt === pendingIcon.alt));
    fetchSvgContentTimeoutId = null;
  }
  if (fetchSvgContentTimeoutId !== null) {
    clearTimeout(fetchSvgContentTimeoutId);
  }
  fetchSvgContentTimeoutId = setTimeout(debouncedFetch, 75);
}
export const SvgIconContext = createContext({});
export const SvgIconProvider = ({
  children
}) => {
  const [icons, setIcons] = useState([]);
  useEffect(() => {
    function newIconEventHandler(event) {
      var _a;
      if (!((_a = event.detail) == null ? void 0 : _a.icons)) return;
      setIcons(icons2 => [...icons2, ...event.detail.icons]);
    }
    svgIconEventTarget.addEventListener("newicons", newIconEventHandler);
    return () => svgIconEventTarget.removeEventListener("newicons", newIconEventHandler);
  }, [icons]);
  function fetchIcon(src, alt) {
    fetchSvgContent(src, alt);
    return "";
  }
  return /* @__PURE__ */jsx(SvgIconContext.Provider, {
    value: {
      icons,
      fetchIcon
    },
    children
  });
};